import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'

interface ConfirmFieldChangeModalProps {
  show: boolean
  onCancel: () => void
  onContinue: () => void
}

export const ConfirmFieldChangeModal: FC<ConfirmFieldChangeModalProps> = ({ show, onCancel, onContinue }) => (
  <Modal
    show={show}
    onHide={onCancel}
    centered
    header={<h5 className='mb-0'>Confirm Change</h5>}
    body={
      <p className='paragraph-medium mb-0'>
        Changing these details affects other parts of the application — the client data and validation steps will need to be reviewed again.
      </p>
    }
    showFooterActions
    footerPrimaryActionTitle='Continue'
    onFooterPrimaryAction={onContinue}
    onFooterSecondaryAction={onCancel}
  />
)
